<template>
    <u-select-solo-rounded v-model="modelValue" v-bind="$attrs" @input="$emit('input', modelValue)">
        <template v-for="(_, slotName) in $slots" #[slotName]>
            <slot :name="slotName" />
        </template>
    </u-select-solo-rounded>
</template>

<script>
import USelectSoloRounded from "@/components/publish/styles/forms/u-select-solo-rounded.vue";

export default {
    props: {
        value: { type: String, default: null },
    },
    components: {
        USelectSoloRounded,
    },
    data() {
        return {
            modelValue: this.$props.value,
        };
    },
    watch: {
        value() {
            this.modelValue = this.value;
        },
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
